import type { Time } from "../time";

import type { DateTimeFormat } from "./date-time-format";

/**
 * TODO STAC-22104 This interface does not add any value, can be replaced with DateTimeFormat
 *
 * @deprecated use DateTimeFormat
 */
export interface CombinedDateTimeFormat extends DateTimeFormat {
	/**
	 * @deprecated used only in tests
	 */
	dateFormat?: DateTimeFormat;
	/**
	 * @deprecated not used
	 */
	clockTimeFormat: DateTimeFormat;
}

export function getCombinedDateTimeFormat(
	dateFormat: undefined | DateTimeFormat,
	clockTimeFormat: DateTimeFormat,
): CombinedDateTimeFormat {
	const format = (time: Time) => {
		if (dateFormat) {
			return `${dateFormat.format(time)}, ${clockTimeFormat.format(time)}`;
		}

		return clockTimeFormat.format(time);
	};

	return {
		format,
		name: (dateFormat?.name ? `${dateFormat.name} + ` : "") + clockTimeFormat.name,
		dateFormat,
		clockTimeFormat,
		pattern: {
			unicode: dateFormat
				? `${dateFormat.pattern.unicode}, ${clockTimeFormat.pattern.unicode}`
				: clockTimeFormat.pattern.unicode,
			g2: dateFormat ? `${dateFormat.pattern.g2}, ${clockTimeFormat.pattern.g2}` : clockTimeFormat.pattern.g2,
		},
	};
}

export interface CombinedDateTimeFormatWithTime extends CombinedDateTimeFormat {
	/**
	 * TODO STAC-22104 toString() is a bad idea because it confuses with the default toString() method.
	 * TODO Instead it should use formatter.format(time). Or even better it should return a formatted string directly because this is the only used case.
	 */
	toString(): string;
}

export function getCombinedDateTimeFormatWithTime(
	time: Time,
	dateFormat: undefined | DateTimeFormat,
	clockTimeFormat: DateTimeFormat,
): CombinedDateTimeFormatWithTime {
	const formatter = getCombinedDateTimeFormat(dateFormat, clockTimeFormat);

	return {
		...formatter,
		toString: () => formatter.format(time),
	};
}
